import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="flex min-h-screen items-center bg-white pt-20">
      <div className="mx-auto max-w-xl px-5 py-24">
        <p className="font-overline text-[10px] uppercase tracking-[0.35em] text-[#e63946]">404</p>
        <h1 className="font-display mt-5 text-4xl font-extrabold tracking-tight text-[#111111] sm:text-5xl">
          Off track.
        </h1>
        <p className="mt-5 text-base leading-relaxed text-neutral-600">
          This address doesn't match an ABS LLC page. It may have moved, or the
          link was typed incorrectly.
        </p>
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="group mt-8 inline-flex items-center gap-2 bg-[#111111] px-7 py-4 text-[13px] font-semibold uppercase tracking-[0.16em] text-white transition-colors duration-300 hover:bg-[#e63946]"
        >
          <ArrowLeft className="h-4 w-4 transition-transform duration-300 group-hover:-translate-x-1" />
          Back to the start line
        </Link>
      </div>
    </div>
  );
}
